<template>
  <div>    
    <div class="wrapper d-flex flex-column min-vh-100 bg-light">
      <div class="body flex-grow-1">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'DefaultLayout',
  components: {},
}
</script>
